import template from './subNav.html'

function subNavDirective($state) {
    return {
        restrict: 'E',
        scope: false,
        replace: false,
        template,
        // link complir 这些函数少许区别 可以看下指令api 说明
        link(scope) {
            scope.selectedClass = function selectedClass(menu) {
                if ($state.params.obj) { // 系统自动生成的菜单配置了参数为functionId
                    if ($state.params.obj == menu.functionId) {
                        return 'active'
                    }
                } else if ($state.current.name.split('.').slice(0, 3).join('.') === menu.url.split('.').slice(0, 3).join('.')) {
                    return 'active'
                }
                return ''
            }
        },
    }
}
subNavDirective.$inject = ['$state']
export default subNavDirective



// WEBPACK FOOTER //
// ./src/components/subNav/subNavDirective.js